var UtilitiesService = function () {
  var toFormattedString = function (useLocale, format, values) {
    /* jshint maxcomplexity:false */
    var result = ''

    for (var i = 0; ;) {
      // Find the next opening or closing brace
      var open = format.indexOf('{', i)
      var close = format.indexOf('}', i)
      if ((open < 0) && (close < 0)) {
        // Not found: copy the end of the string and break
        result += format.slice(i)
        break
      }
      if ((close > 0) && ((close < open) || (open < 0))) {
        if (format.charAt(close + 1) !== '}') {
          throw new Error('missing open bracket')
        }

        result += format.slice(i, close + 1)
        i = close + 2
        continue
      }

      // Copy the string before the brace
      result += format.slice(i, open)
      i = open + 1

      // Check for double braces (which display as one and are not arguments)
      if (format.charAt(i) === '{') {
        result += '{'
        i++
        continue
      }

      if (close < 0) {
        throw new Error('missing close bracket')
      }

      // Find the closing brace

      // Get the string between the braces, and split it around the ':' (if any)
      var brace = format.substring(i, close)
      var colonIndex = brace.indexOf(':')
      var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10)

      if (isNaN(argNumber)) {
        throw new Error('format stringFormatInvalid')
      }

      var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1)

      var arg = values[argNumber]
      if (arg === undefined || arg === null) {
        arg = ''
      }

      // If it has a toFormattedString method, call it.  Otherwise, call toString()
      if (arg.toFormattedString) {
        result += arg.toFormattedString(argFormat)
      } else if (useLocale && arg.localeFormat) {
        result += arg.localeFormat(argFormat)
      } else if (arg.format) {
        result += arg.format(argFormat)
      } else {
        result += arg.toString()
      }

      i = close + 1
    }

    return result
  }

  return {
    sortByKey: function (array, key) {
      var clonedArray = array.slice()
      return clonedArray.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        let result
        if (x === y) {
          result = 0
        } else if (x === null) {
          return 1
        } else if (y === null) {
          return -1
        } else if (x > y) {
          result = 1
        } else if (x < y) {
          return -1
        } else {
          return 0 // ???
        }
        return result
      })
    },
    railObjectClass: function (railObject) {
      if (!railObject) {
        return ''
      }
      if (railObject.OperationModeId === 5) {
        return 'maintenance'
      } else {
        switch (railObject.MonitorStatusId) {
          case 1:
            return 'normal'
          case 2:
            return 'warning'
          case 3:
            return 'error'
          default:
            return 'unknown'
        }
      }
    },
    statusClass: function (status) {
      switch (status) {
        case 1:
          return 'ok'
        case 2:
          return 'warning'
        case 3:
          return 'error'
        default:
          return 'unknown'
      }
    },
    statusColor: function (status) {
      switch (status) {
        case 1:
          return '#4CAF50'
        case 2:
          return '#FF9800'
        case 3:
          return '#C91414'
        default:
          return '#C8C8C8'
      }
    },
    propsFilter: function (items, props) {
      var out = []

      if (Array.isArray(items)) {
        items.forEach(function (item) {
          var itemMatches = false

          var keys = Object.keys(props)
          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i]
            if (props[prop] !== undefined) {
              var text = props[prop].toLowerCase()
              if (item[prop] !== null && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                itemMatches = true
                break
              }
            } else {
              itemMatches = true
              break
            }
          }

          if (itemMatches) {
            out.push(item)
          }
        })
      } else {
        // Let the output be the input untouched
        out = items
      }
      return out
    },
    stringFormat: function (template, values) {
      if (!values || !values.length || !template) {
        return template
      }
      try {
        return toFormattedString(false, template, values)
      } catch (err) {
        throw err
      }
    },
    hexToRgbA (hex, opacity) {
      var c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
      }
      throw new Error('Bad Hex')
    },
    complexSorted: function (complexUnsorted) {
      var newList = []
      complexUnsorted.forEach((complex) => {
        var text = complex.Name
        // Step 1: Remove all spaces
        text = text.replace(/\s+/g, '')
        // Step 2: Convert to lowercase
        text = text.toLowerCase()
        // Step 3: Replace any 6-digit numbers to be exactly 6 digits with trailing zeros
        text = text.replace(/\d{1,6}/g, match => match.padStart(6, '0'))
        complex.NameSort = text
        newList.push(complex)
      })
      return newList.slice().sort((a, b) => {
        const complA = a.NameSort
        const complB = b.NameSort
        return complA.localeCompare(complB, undefined, { numeric: true, sensitivity: 'base' })
      })
    },
    railObjectsSorted: function (railObjectsUnsorted) {
      var newList = []
      railObjectsUnsorted.forEach((railObject) => {
        var text = railObject.Name
        // Step 1: Remove all spaces
        text = text.replace(/\s+/g, '')
        // Step 2: Convert to lowercase
        text = text.toLowerCase()
        // Step 3: Replace any 6-digit numbers to be exactly 6 digits with trailing zeros
        text = text.replace(/\d{1,6}/g, match => match.padStart(6, '0'))
        railObject.NameSort = text
        newList.push(railObject)
      })
      return newList.slice().sort((a, b) => {
        const railobjA = a.NameSort
        const railobjB = b.NameSort
        return railobjA.localeCompare(railobjB, undefined, { numeric: true, sensitivity: 'base' })
      })
    }
  }
}

export default new UtilitiesService()



// WEBPACK FOOTER //
// ./src/services/UtilitiesService.js